import { render, staticRenderFns } from "./SupervisorList.vue?vue&type=template&id=82a038bc"
import script from "./SupervisorList.vue?vue&type=script&lang=js"
export * from "./SupervisorList.vue?vue&type=script&lang=js"
import style0 from "./SupervisorList.vue?vue&type=style&index=0&id=82a038bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports